const selectProjects = {
	init() {
		console.log("select projects");

		// const dropdownButton = document.querySelector(".js-dropdown-button");
		// const dropdownMenu = document.querySelector(".js-dropdown-menu");
		const categoryDropdown = document.querySelectorAll(
			".js-category-dropdown"
		);

		categoryDropdown.forEach((element) => {
			const dropdownButton = element.querySelector(".js-dropdown-button");
			const dropdownMenu = element.querySelector(".js-dropdown-menu");

			if (dropdownButton && dropdownMenu) {
				// Function to hide dropdown menu
				function hideDropdownMenu() {
					console.log("Dropdown menu hidden");
					dropdownMenu.classList.add("hidden");
				}

				// Function to show dropdown menu
				function showDropdownMenu() {
					console.log("Dropdown menu shown");
					dropdownMenu.classList.remove("hidden");
				}

				// Toggle the dropdown menu visibility
				dropdownButton.addEventListener("click", function () {
					dropdownMenu.classList.toggle("hidden");
					console.log("Dropdown button clicked");
				});

				// Hide the dropdown when clicking outside
				document.addEventListener("click", function (event) {
					if (
						!dropdownButton.contains(event.target) &&
						!dropdownMenu.contains(event.target)
					) {
						hideDropdownMenu();
						console.log("Clicked outside. Dropdown hidden");
					}
				});

				// Ensure dropdown is hidden on initial load and pageshow
				document.addEventListener("DOMContentLoaded", function () {
					console.log("Initial load. Hiding dropdown menu");
					hideDropdownMenu();
				});

				window.addEventListener("pageshow", function (event) {
					if (event.persisted) {
						console.log("Pageshow event. Hiding dropdown menu");
						hideDropdownMenu();
					}
				});

				// Reset dropdown state when navigating away from the page
				window.addEventListener("beforeunload", function () {
					console.log("Beforeunload event. Hiding dropdown menu");
					hideDropdownMenu();
				});

				// Log initial state
				console.log("Script loaded. Dropdown is hidden by default.");
			}
		});
	},
};

export default selectProjects;
